import React from 'react';
import PropTypes from 'prop-types';

export const ArrowUpIcon = ({ className = '', width = '20', height = '20', fill = '#8696a0' }) => (
    <svg className={className} width={width} height={height} viewBox="0 0 20 20" fill={fill}>
        <path d="M10 7l-5 5h10l-5-5z" />
    </svg>
);

ArrowUpIcon.propTypes = {
    className: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
};

export const ArrowDownIcon = ({ className = '', width = '20', height = '20', fill = '#8696a0' }) => (
    <svg className={className} width={width} height={height} viewBox="0 0 20 20" fill={fill}>
        <path d="M10 13l5-5H5l5 5z" />
    </svg>
);

ArrowDownIcon.propTypes = {
    className: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
};
